import React, {useContext, useEffect, useState} from 'react';
import Userprofiledropdownblock from './Userprofiledropdownblock/Userprofiledropdownblock';
import { getImageUrl } from '../hooks/helpers';
import {AppDataContext, isJSON} from '@iblai/ibl-web-react-common';
import $ from 'jquery';
import { useDebounce } from '../hooks/useDebounce';

const Headerprofilemenue = () => {
  const { appData, setAppData } = useContext(AppDataContext);
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  const handleProfileDropdown = () => {
    $('.div-block-167').on('click', function(){
      $('.div-block-164.profile').addClass('open')
    })
    //HIDING DROPDOWN WHEN CLICKING ELSEWHERE
    $(document).on('click', function (e) {
      if ($('.div-block-164.profile:visible').hasClass("open") && !$(e.target).closest('.div-block-167').length) {
        $('.div-block-164.profile:visible').removeClass('open')
      }
    });
  }
  const handleProfileClick = () => {
    //setIsPopupOpen(true);
    $('.div-block-164.profile:visible').toggleClass('open')
  };

  useEffect(() => {

  }, [appData.userData, appData.userMetaData]);

  useDebounce(handleProfileDropdown, 200, [])
  return (
    <>
      <div className="div-block-167" >
        <div className="text-block-370">{appData.userMetaData?.name}</div>
        <img
          src={getImageUrl(appData.userMetaData?.profile_image?.image_url_full)}
          loading="lazy"
          alt=""
          className="image-4"
        />
        <img
          src="https://assets-global.website-files.com/6596e21ac435cac3c66baad8/6596e21ac435cac3c66bac99_629f2d70ada2d5ad683a0982_down-arrow.png"
          loading="lazy"
          alt=""
          className="image-5"
        />
        <Userprofiledropdownblock userData={appData.userData} />
      </div>
    </>
  );
};

export default Headerprofilemenue;
